export type StartEndTimeMode = "manual" | "live";

export const mapLinkWithParamsRoute = "/map?";

type MapLinkParams = {
  date: string;
  officeId?: string;
  resourceId?: string;
  floorId?: string;
  startTime?: string;
  endTime?: string;
  timeMode?: StartEndTimeMode;
  searchText?: string;
  section?: "people" | "rooms" | "desks" | "other";
};

enum v2MapLinkParamsKeys {
  // used in MapPage
  date = "date",
  endTime = "endTime",
  floorId = "floorId",
  startTime = "startTime",
  timeMode = "timeMode",
  resource = "resource",

  // dateTime only parsed from hash, don't use it query
  // dateTime = 'dateTime',

  office = "officeId",

  // used in MapFiltersCard for side panel
  searchText = "searchText",
  section = "section"
}

/**
 *
 * @param {MapLinkParams} param0
 * @returns {string}
 * @description Creates a map link with the given parameters,
 * use dateStringToLocalTime to convert date and times
 * @example
 * const link = createMapLink({
 *   date: '2025-11-12',
 *   officeId: 'offi_46cde38b-656e-419c-951d-7917fb333c31',
 *   resourceId: 'reso_5271f2b5-0dc5-44d8-a3a5-424924e6e07a',
 *   floorId: 'reso_cdd8b424-1f25-4411-a49c-961cbfdb1ebb',
 * });
 */
export const createMapLink = ({
  date,
  officeId,
  resourceId,
  floorId,
  startTime,
  endTime,
  timeMode = "manual",
  searchText,
  section = "people"
}: MapLinkParams) => {
  const dateStr = date.split("T")[0];
  const params = new URLSearchParams();

  // takes day or date and time, it schedule is available
  if (date) {
    params.set(v2MapLinkParamsKeys.date, startTime ?? dateStr);
  }
  if (officeId) {
    params.set(v2MapLinkParamsKeys.office, officeId);
  }
  if (floorId) {
    params.set(v2MapLinkParamsKeys.floorId, floorId);
  }
  if (resourceId) {
    params.set(v2MapLinkParamsKeys.resource, resourceId);
  }
  if (startTime) {
    params.set(v2MapLinkParamsKeys.startTime, startTime);
  }
  if (endTime) {
    params.set(v2MapLinkParamsKeys.endTime, endTime);
  }
  if (timeMode) {
    params.set(v2MapLinkParamsKeys.timeMode, timeMode);
  }
  if (searchText) {
    params.set(v2MapLinkParamsKeys.searchText, searchText);
  }
  if (section) {
    params.set(v2MapLinkParamsKeys.section, section);
  }
  return `${mapLinkWithParamsRoute}${params.toString()}`;
};
